
import Messaging from "../pages/Messaging";
export const messagingRoutes = [
  {
    path: "messaging",
    name: "پیام رسانی",
    component: Messaging,
  },
  
];
export default messagingRoutes;